<template>
  <div class="item">
    <v-container class="my-5">
      <v-row>
        <v-col>
          <ItemSIMStatus v-if="(item && item.iccid) && !editMode" :propItem="item" />
        </v-col>
        <v-col>
          <ItemPVSStatus v-if="item && !editMode" :propItem="item" />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <ShowItem v-if="item && !editMode" :propItem="item" @editMode="editMode = !editMode" />
          <EditItem v-if="item && editMode" :propItem="item" @editMode="editMode = !editMode" @closeEdit="closeEdit" />
        </v-col>
      </v-row>

      <v-row v-if="!editMode">
        <v-col>
          <ItemLogs v-if="itemLogs" :propLogs="itemLogs" :propHeaders="itemLogHeaders" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios'
import ItemSIMStatus from '@/components/ItemSIMStatus'
import ItemPVSStatus from '@/components/ItemPVSStatus'
import ShowItem from '@/components/ShowItem'
import EditItem from '@/components/EditItem'
import ItemLogs from '@/components/ItemLogs'

export default {
  name: 'Item',

  components: {
    ItemSIMStatus,
    ItemPVSStatus,
    ShowItem,
    EditItem,
    ItemLogs
  },

  data: () => ({
    item: null,
    itemLogs: null,
    tags: null,
    editMode: false,
    itemLogHeaders: [
      { text: 'Created', value: 'createdAt' },
      { text: 'Notes', value: 'notes' },
      { text: 'Tags', value: 'Tags' },
      { text: 'Diff', value: 'diff' },
      { text: 'Performing User', value: 'performingUser' }
    ]
  }),

  mounted () {
    this.getItemById(this.$route.params.itemId)
  },

  methods: {
    async getItemById (itemId) {
      let result
      try {
        result = await axios.get(process.env.VUE_APP_API_URL + '/item/' + itemId)
      } catch (err) {
        console.error('Error trying to getItemById axios.get()', err)
        this.$router.push('/')
      }

      this.item = result.data
      this.parseLogs(result.data.Logs)
    },

    parseLogs (logs) {
      this.itemLogs = logs.map(log => {
        const diff = JSON.stringify(log.diff)
        return Object.assign({}, log, { diff })
      })
    },

    closeEdit () {
      this.editMode = false
      this.$root.$emit('itemUpdated')
      this.getItemById(this.item.id)
    }
  },

  computed: {
    locations () {
      return this.$store.state.locations
    }
  }
}
</script>
